import { render, staticRenderFns } from "./animation.vue?vue&type=template&id=7b4c1c48&scoped=true&lang=html&"
import script from "./animation.vue?vue&type=script&lang=js&"
export * from "./animation.vue?vue&type=script&lang=js&"
import style0 from "./animation.vue?vue&type=style&index=0&id=7b4c1c48&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4c1c48",
  null
  
)

component.options.__file = "animation.vue"
export default component.exports